import { keepPreviousData } from '@tanstack/react-query';
import { AGGREGATE_NAMES, LOAN_REQUEST_RESOLVERS } from 'cpool-constants';
import { schemaLoanRequestResolver_Get } from 'cpool-tables/backend-resolvers';

import { useAggregateQuery } from '~/queryUtils/useQuery';
import { useQueryPositionStore } from '~/store/queryPositionStore.ts';
import { queryKeys } from '~/utils/queryKeys';

const useLead = (id?: string) => {
    const queryKey = queryKeys.get(id ?? '');
    const queryPosition = useQueryPositionStore((state) => state.positions[JSON.stringify(queryKey)]);

    return useAggregateQuery({
        acl: { loanRequestId: id },
        aggregateName: AGGREGATE_NAMES.LOAN_REQUEST,
        resolverName: LOAN_REQUEST_RESOLVERS.get,
        schema: schemaLoanRequestResolver_Get.nullable(),
        searchParams: { id, position: queryPosition },
        tanstack: {
            enabled: !!id,
            placeholderData: keepPreviousData,
        },
    });
};

export default useLead;
